// React
import React, { useEffect, useRef, useContext, useState } from "react";
// React
// CSS
import styles from "./FullQuizCreatorModal.module.css";
// CSS
// Utils
import HelperHeader from "../../../../Utils/HelperHeader/HelperHeader";
// Utils
// Images
import { dialog_shop_header } from "../../../../Images/images";
// Images
// Models
import { I_FullQuizItem } from "../../../../Models/interfaces";
// Models
// Services
import { buyQuizService } from "../../../../Services/Buy/post/buyQuizService";
import { showQuestionsOfBoughtQuiz } from "../../../../Services/Quiz/post/showQuestionsOfBoughtQuiz";
// Services
// Contexts
import { UserTokenContext } from "../../../../Contexts/userToken";
import { SetUserQuestionContext } from "../../../../Contexts/SetUserQuestionContext";
import { SetLessonDataContext } from "../../../../Contexts/SetLessonDataContext";
// import { LessonDataContext } from "../../../../Contexts/LessonDataContext";
// Contexts
// Modules
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../../Utils/Spinner/Spinner";
import { toast } from "react-toastify";
import { getFullQuizDataService } from "../../../../Services/Quiz/get/getFullQuizDataService";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {getUserProfile_Service} from "../../../../Services/Profile/get/getUserProfile_Service";
// Modules

type FullQuizCreatorModalProps = {
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
  modalData: I_FullQuizItem | undefined;
  setReceivedQuiz: React.Dispatch<React.SetStateAction<I_FullQuizItem[]>>;
};

const FullQuizCreatorModal: React.FunctionComponent<
  FullQuizCreatorModalProps
> = ({ setIsModalInScreen, modalData, setReceivedQuiz }) => {
  // const { early_price, gift_price, id, title } = modalData;
  //
  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);
  //
  const userToken = useContext(UserTokenContext);
  const setQuestions = useContext(SetUserQuestionContext);
  const setLessonData = useContext(SetLessonDataContext);
  //
  const navigate = useNavigate();
  //
  const [isPending, setIsPending] = useState<boolean>(false);
  const [isWalletPending, setIsWalletPending] = useState<boolean>(true);
  const [wallet, setWallet] = useState<number>(0);
  const [giftWallet, setGiftWallet] = useState<number>(0);
  const [payWithWallet, setPayWithWallet] = useState<number>(0);
  const [payWithGiftWallet, setPayWithGiftWallet] = useState<number>(0);
  const [finalPrice, setFinalPrice] = useState<number>(Number(modalData?.is_locked ? modalData?.early_price : modalData?.gift_price));
  //
  const [stat, setStat] = useState<string>("");
  useEffect(() => {
    setTimeout(() => {
      if (!outerRef.current) return;
      if (!innerRef.current) return;
      innerRef.current.style.top = "0";
      outerRef.current.style.opacity = "1";
    }, 30);
  }, []);

  const closeModal = () => {
    if (!outerRef.current) return;
    if (!innerRef.current) return;
    outerRef.current.style.opacity = "0";
    innerRef.current.style.top = "120vh";
    setTimeout(() => {
      setIsModalInScreen(false);
    }, 500);
  };

  useEffect(() => {
    let final_price =  Number(modalData?.is_locked ? modalData?.early_price : modalData?.gift_price);
    if(payWithGiftWallet){
      if(final_price > giftWallet){
        final_price -= giftWallet;
      }else{
        final_price = 0;
      }
    }
    if(payWithWallet){
      if(final_price > wallet){
        final_price -= wallet;
      }else{
        final_price = 0;
      }
    }
    setFinalPrice(final_price);
  }, [payWithWallet,payWithGiftWallet,wallet,giftWallet,modalData]);

  useEffect(() => {
    if(modalData?.has_paid){
      setIsWalletPending(false);
    }else{
      getUserProfile_Service(userToken)
          .then(({ data: { data } }) => {
            setWallet(data.wallet);
            setGiftWallet(data.gift_wallet);
            // console.log(data);
            setIsWalletPending(false);
          })
          .catch((err: any) => {
            setIsWalletPending(false);
            toast(
                err.response.data.message ? err.response.data.message : err.message
            );
          });
    }
  }, [userToken]);

  return (
    <div
      className={`${styles.modalContainer} fixed top-0 ${
        window.innerWidth > 600 ? "left-auto ml-1" : "left-0"
      } w-screen h-screen flex items-center justify-center z-30`}
    >
      <div
        className={`${styles.outer} z-40 w-screen h-screen absolute top-0 left-0`}
        onClick={closeModal}
        ref={outerRef}
      ></div>
      <div
        className={`${styles.inner} relative p-4 bg-white z-50 rounded-lg`}
        ref={innerRef}
      >
        <HelperHeader absoluteText=" خریــــد محـــــصول " isBgWhite={true} />
        <img src={dialog_shop_header} alt="" />
        <p className="w-full text-right mt-4">{modalData?.title}</p>
        <p className="w-full text-right mt-1">
          <span className="text-sm font-bold">
            {modalData?.is_locked
              ? modalData?.early_price
              : modalData?.gift_price}
          </span>
          <span className="text-xs mt-2">
            {modalData?.is_locked ? "تومان(پیش گشایش)" : "تومان (کیف پول هدیه)"}
          </span>
        </p>
        {
          !modalData?.has_paid ?
              (
                  <>
                    <p className="mt-6" style={{display:"flex",direction:"rtl"}}>
                      <div style={{display:"flex",alignItems:"center"}}>
                        <input disabled={!giftWallet} className="ml-2" onChange={()=>{setPayWithGiftWallet((state) => state?0:1)}} type="checkbox"/>
                        <label>کیف پول هدیه : </label>
                      </div>
                      <div>
                        {isWalletPending ?
                            (<SkeletonTheme
                                baseColor="rgba(126, 58, 229 , 0.1)"
                                highlightColor="rgba(126, 0, 229, 0.6)"
                            >
                              <Skeleton
                                  count={1}
                                  width={"40px"}
                                  height={"20px"}
                                  style={{ marginRight: "10px" }}
                              />
                            </SkeletonTheme>)
                            :
                            (<span className="mr-1">{giftWallet}</span>)
                        }
                      </div>
                    </p>
                    <p className="mt-1" style={{display:"flex",direction:"rtl"}}>
                      <div style={{display:"flex",alignItems:"center"}}>
                        <input disabled={!wallet} className="ml-2" onChange={()=>{setPayWithWallet((state) => state?0:1)}} type="checkbox"/>
                        <label>کیف پول اصلی : </label>
                      </div>
                      <div>
                        {isWalletPending ?
                            (<SkeletonTheme
                                baseColor="rgba(126, 58, 229 , 0.1)"
                                highlightColor="rgba(126, 0, 229, 0.6)"
                            >
                              <Skeleton
                                  count={1}
                                  width={"40px"}
                                  height={"20px"}
                                  style={{ marginRight: "10px" }}
                              />
                            </SkeletonTheme>)
                            :
                            (<span className="mr-1">{wallet}</span>)
                        }
                      </div>
                    </p>
                  </>
              )
              :""
        }
        <button
          className="w-full text-center mt-4 text-white rounded-lg py-2 flex items-center justify-center"
          onClick={() => {
            if (isPending) return;
            setIsPending(true);
            if (modalData?.has_paid) {
              showQuestionsOfBoughtQuiz(
                userToken,
                String(modalData ? modalData.id : "")
              )
                .then(
                  ({
                    data: {
                      data,
                      quiz: { id },
                    },
                  }) => {
                    if (!setQuestions) return;
                    if (!setLessonData) return;
                    setQuestions(data);
                    setIsPending(false);
                    console.log("xxx", data);
                    setLessonData((prevState) => ({
                      ...prevState,
                      lessonId: data[0].lesson_id,
                    }));
                    return id;
                  }
                )
                .then((id) => {
                  Swal.fire({
                    icon: "success",
                    title: "سوالات با موفقیت دریافت شد",
                    confirmButtonText: "رفتن به صفحه آزمون",
                    cancelButtonText: "لغو",
                    showCancelButton: true,
                  }).then(({ isConfirmed }) => {
                    if (isConfirmed) {
                      navigate("/quiz-maker/quiz-questions", {
                        state: {
                          isFullQuiz: true,
                          currMode: "full",
                          quizId: String(id),
                        },
                      });
                      return;
                    } else {
                      return;
                    }
                  });
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire({
                    icon: "error",
                    title: err?.response?.data?.message
                      ? err?.response?.data?.message
                      : err.message,
                  });
                });
              return;
            }
            buyQuizService(userToken, String(modalData ? modalData.id : ""),payWithWallet,payWithGiftWallet)
              .then(({ data }) => {
                if (data.url) {
                  window.location.href = data.url;
                  setIsPending(false);
                  return;
                }
                Swal.fire({ icon: "info", title: data.data }).then(() => {
                  setStat("x");
                  getFullQuizDataService(userToken).then(
                    ({ data: { data } }) => {
                      setReceivedQuiz(data);
                      closeModal();
                    }
                  );
                });
              })
              .catch((err) => {
                console.log(err);
                toast(
                  err.response.data.message
                    ? err.response.data.message
                    : err.message
                );
              });
          }}
          dir="rtl"
        >
          {isPending || isWalletPending ? (
            <>{stat === "" ? <Spinner /> : "در حال بروز رسانی"}</>
          ) : (
            <>
              {modalData?.has_paid ? <>ورود به آزمون</> :
                  Number(modalData?.is_locked ? modalData?.early_price : modalData?.gift_price) === 0 ? (
                      <>استفاده ی رایگان</>
                  ) : (
                  <>
                    <span className="float-right">پرداخت</span>
                    <span className={"mr-1 " + ((payWithWallet || payWithGiftWallet) ? 'line-through' :'')}>{Number(modalData?.is_locked ? modalData?.early_price : modalData?.gift_price)} تومان</span>
                    {
                      (payWithWallet || payWithGiftWallet) ?
                          (<span className="mr-2">{finalPrice} تومان</span>) : ""
                    }
                  </>
                  )
              }
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FullQuizCreatorModal;
